import { combineReducers } from "redux"
import { setterReducer } from "../common/redux"
import * as t from "./actionTypes"
import * as authActions from "../auth/actionTypes"
import * as embedActions from "../embed/actionTypes"
import * as integrationActions from "../integration/actionTypes"


const INITIAL_PLAN_DETAIL_STATE = {
  options: [],
  selected: null
}

const INITIAL_LOADED_STATE = {
  brand: false,
  auth: false,
  recommendations: false,
  planInfo: false
}

const planDetailReducer = (basename, initialState=INITIAL_PLAN_DETAIL_STATE) => (state=initialState, action) => {
  switch(action.type) {
    case t[`SET_${basename}S`]:
      return {selected: null, options: action.payload }
    case t[`SELECT_${basename}`]:
      return {...state, selected: action.payload }
    default:
      return state
  }
}

const loaded = (state=INITIAL_LOADED_STATE, action) => {
  switch(action.type) {
    case authActions.SET_LOGIN_STATUS:
      return {
        ...state,
        auth: true
      }
    case embedActions.GET_BRAND_SUCCESS:
      return {
        ...state,
        brand: true
      }
    case integrationActions.SET_MARKETPLACE_TOKEN:
      return {
          ...state,
          brand: true
        }
    case t.SET_RECOMMENDATIONS:
      return {
        ...state,
        recommendations: true
      }
    default:
      return state
  }
}

const holder = setterReducer(null, t.SELECT_HOLDER)
const office = planDetailReducer("OFFICE")
const plan = planDetailReducer("PLAN")
const planInformation = setterReducer(true, t.SET_PLAN_INFORMATION)
const planProvider = planDetailReducer("PLAN_PROVIDER")
const recommendations = setterReducer(null, t.SET_RECOMMENDATIONS)

const dashboard = combineReducers({
  holder,
  loaded,
  office,
  plan,
  planInformation,
  planProvider,
  recommendations
})

export { dashboard as default }



// WEBPACK FOOTER //
// ./assets/dashboard/reducer.js